import { render } from "./PayoutsList.vue?vue&type=template&id=8bb503c2&ts=true"
import script from "./PayoutsList.vue?vue&type=script&lang=ts"
export * from "./PayoutsList.vue?vue&type=script&lang=ts"

import "./PayoutsList.vue?vue&type=style&index=0&id=8bb503c2&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__